/* eslint-disable */
/* tslint:disable */

/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface WebBlog {
    /** 【算法接口同步】帖子id */
    id?: string | null;

    /** 发帖人id */
    guid?: string | null;

    /** 【算法接口同步】审核上下线状态 >1： 上线 0： 待审核 <0: 下线 */
    checkStatus?: number | null;

    /** 上下线原因 */
    checkReason?: string | null;

    /** 审核时间 */
    checkTime?: string | null;

    /** 【算法接口同步】帖子类型 short:短内容 translate:编译 predict:预言 */
    type?: string | null;

    /** 【算法接口同步】预言，编译的标题，可以为空 */
    title?: string | null;

    /** 【算法接口同步】超文本字段，存储帖子正文所有内容，烙饼专用 */
    post?: string | null;

    /** 【算法接口同步】转发帖子id,forwardStatus  为 1或者2 时，  forwardId不能为空 */
    forwardId?: string | null;

    /** 【算法接口同步】转发状态：0推文   1 转推  2 引用 */
    forwardStatus?: number | null;

    /** 【算法接口同步】在用/假删 标志位，1 在用-1 删除 */
    useFlag?: number | null;

    /** 【算法接口同步】可见性1 ：仅自己 2 ：粉丝 3 ：所有人 */
    visibility?: number | null;

    /** 发布状态 draft: 草稿 checking: 审核中 published: 已发布 */
    publish?: string | null;

    /** 操作人（域帐号信息） */
    opUser?: string | null;

    /** 【算法接口同步】话题id（新增、类型通用） */
    topicId?: string | null;

    /** 【算法接口同步】话题名称（新增、类型通用） */
    topicTitle?: string | null;

    /** 地理位置信息（新增，编译） */
    location?: string | null;

    /** 【算法接口同步】编辑的摘要部分，字符串 ； 预言的预览部分json字符串 */
    summary?: string | null;

    /** 长文本编辑器正文部分（编译类型正文，预言类型 预览部分） */
    richContent?: string | null;

    /** 【算法接口同步】长文本编辑器资源部分（videoList,imageList） */
    richResource?: string | null;

    /** 【算法接口同步】揭晓时间（新增，预言要求必传） */
    unlockTime?: string | null;

    /** 【算法接口同步】源站信息，非必填，编译时会用到，示例：{"title": "原文标题",  //非必填"link": "原文链接", //非必填"summary": "原文摘要" //非必填} */
    sourceInfo?: string | null;

    /** 文章标签（热） */
    label?: string | null;

    /** 【算法接口同步】原始帖id，转推线 */
    originalId?: string | null;

    /** ip地址 */
    ipLocation?: string | null;

    /** 展示样式（全部小写，与统计方一致） */
    showtype?: string | null;

    /** 长编辑器发文正文字段（不在数据库中存储，仅用于发文使用） */
    contentText?: string | null;

    /** 上下线状态 1：上线，0：下线，-1：待处理 */
    state?: number | null;

    /** 推文等级，1：低质，2：普通，3：良好，4：优质 */
    qlevel?: number | null;

    /** 一级分类 */
    cate?: string | null;

    /** 二级分类 */
    subcate?: string | null;

    /** 时效：短100，正常300，长效9999 */
    timeliness?: number | null;

    /** 过期时间 */
    expireTime?: string | null;

    /** 标签 */
    labels?: string | null;

    /** 推荐状态， -1：待处理，2：可推，0不可推 */
    recomState?: number | null;

    /** 标记 （神预言，精品） */
    mark?: string | null;

    /** 来源（bflow，bflow_frontend，bflow_backend） */
    source?: string | null;

    /** 【算法接口同步】创建时间 */
    ctime?: string | null;

    /** 【算法接口同步】更新时间 */
    utime?: string | null;

    /** 创建人 */
    cuser?: string | null;

    /** 更新人 */
    uuser?: string | null;

    /** 更新来源 */
    usource?: string | null;
}

export interface UserBlogNum {
    /** 用户id */
    guid: string;

    /** 全部发文量 */
    docNum: number;

    /** 短内容发文量（除去引用，转发） */
    shortPostNum: number;

    /** 引用转发数量 */
    fwNum: number;

    /** 编译数量 */
    transNum: number;

    /** 预言数量 */
    predicateNum: number;

    /** 媒体数量（视频图片） */
    mediaNum: number;

    /** 喜欢数量 */
    like: number;
}

export interface RecomParam {
    /** 设备id */
    uid: string;

    /** 用户id */
    guid?: string;

    /** 要查看的用户主页id */
    searchGuid?: string;

    /** 话题id */
    topicId?: string;

    /** 帖子id */
    webBlogId?: string;

    /** 查询类型 */
    type?: string;

    /** 一刷推荐几条 */
    pushCount: number;

    /** 第几刷 */
    pullCount: number;

    /** 操作类型 */
    operation?: 'pullDown' | 'pullUp' | 'default';

    /** 实时地理位置 */
    loc?: string;
}

export interface Vote {
    id?: string | null;
    choosetype?: 'single' | null;
    questionid?: string | null;
    expireType?: string | null;
    period?: string | null;
    endtime?: string | null;
    votecount?: number | null;
    status?: string | null;
    voted?: boolean | null;
    expire?: string | null;
    ismust?: string | null;
    option?: { itemid: string; title: string; num: number; selected: boolean }[] | null;
}

export interface Video {
    /** 内容类型，值为 video */
    type: 'video';

    /** 视频id，跟RichResource中的视频id对应 */
    key: string;

    /** 视频大小，单位为字节 */
    size: number;

    /** 视频实际高度 */
    height: number;

    /** 视频实际宽度 */
    width: number;

    /** 视频地址 */
    url: string;

    /** 视频长度，单位秒 */
    timer: number;

    /** 视频封面地址 */
    posterImg: string;
}

export interface Image {
    /** 类型，值为 image */
    type: 'image';

    /** 图片id，跟RichResource中的图片id对应 */
    key: string;

    /** 图片大小，单位为字节 */
    size: number;

    /** 图片实际高度 */
    height: number;

    /** 图片实际宽度 */
    width: number;

    /** 图片地址 */
    url: string;
}

export interface Paragraph {
    /** 类型，值为 paragraph */
    type: 'paragraph';

    /** 文字可以是多段文字 */
    children: { text: string }[];
}

export interface RichResource {
    htmlContent: string;
    imageList: { height: number; intranetUrl: string; key: string; size: number; url: string; width: number }[];
    videoList: {
        url: string;
        posterImg: string;
        timer: string;
        width: number;
        height: number;
        key: string;
        size: number;
    }[];
}

export type RichContent = (Paragraph | Image | Video | (Paragraph & Image & Video))[];

export interface Operator {
    /** 请求来源 */
    source?: string | null;

    /** 请求uid, 可以不是用户ID, 可以是运营id */
    uid?: string | null;
}

export interface Page {
    asc?: (string | null)[];
    ascs?: (string | null)[];
    countId?: string | null;
    current?: number | null;
    desc?: (string | null)[];
    descs?: (string | null)[];
    hitCount?: boolean | null;
    maxLimit?: number | null;
    optimizeCountSql?: boolean | null;

    /** OrderItem */
    orders?: (string | null)[];
    pages?: number | null;

    /** 查询结果 */
    records?: (string | null)[];
    searchCount?: boolean | null;
    size?: number | null;
    total?: number | null;
}

export interface Post {
    /** 是否有文本信息 */
    hasContent?: boolean | null;

    /** 是否有外链 */
    hasLink?: boolean | null;

    /** 是否有视频 */
    hasVideo?: boolean | null;

    /** 是否有图片 */
    hasImage?: boolean | null;

    /** 是否有投票信息 */
    hasVote?: boolean | null;
    text?: { type?: 'text' | 'hypertext' | null; content?: string | null };
    images?: {
        url?: string | null;
        originalUrl?: string | null;
        width?: number | null;
        height?: number | null;
        size?: number | null;
        scene?: 'normal' | 'summary' | 'content' | null;
    }[];
    video?: {
        url?: string | null;
        thumbnail?: string | null;
        bigImg?: string | null;
        duration?: number | null;
        fileSize?: number | null;
        width?: number | null;
        height?: number | null;
        scene?: 'normal' | 'summary' | 'content' | null;
    };
    link?: {
        type?: string | null;
        title?: string | null;
        url?: string | null;
        thumbnail?: string | null;
        source?: string | null;
        shareUrl?: string | null;
    };
    vote?: (Vote | null) | null;
}

export interface FeedFlowItem {
    /** 帖子id */
    id?: string | null;

    /** 发帖人id */
    guid?: string | null;

    /** 用户相关信息 */
    author?: FeedUserInfo | null;

    /** 审核上下线状态 >1： 上线 0： 待审核 <0: 下线 */
    checkStatus?: number | null;

    /** 上下线原因 */
    checkReason?: string | null;

    /** 帖子主体部分，参照最下面json */
    post?: Post | null;

    /** 帖子类型   short:短内容   translate:编译   predict:预言 */
    type?: string | null;

    /** 转发帖子id, type类型为  forward/ quote 不能为空 */
    forwardId?: string | null;

    /** 原始帖子id，主要用于转发链的拼接 */
    originalId?: string | null;

    /** 转发状态：0推文   1 转推  2 引用 */
    forwardStatus?: number | null;

    /** 可见性 1 ：仅自己 2 ：粉丝 3 ：所有人 */
    visibility?: number | null;

    /** 发布状态 draft: 草稿 checking: 审核中 published: 已发布 */
    publish?: string | null;

    /** 操作人（域帐号信息） */
    opUser?: string | null;

    /** 话题id */
    topicId?: string | null;

    /** 话题名称 */
    topicTitle?: string | null;

    /** 话题相关信息 */
    topicInfo?: Topic | null;

    /** 地理位置信息 */
    location?: string | null;

    /** ip位置信息 */
    ipLocation?: string | null;

    /** 预言，编译的标题 */
    title?: string | null;

    /** 摘要（新增、预言要求必传） */
    summary?: string | null;
    richContent?: string | null;
    richResource?: string | null;

    /** 揭晓时间（新增，预言要求必传） */
    unlockTime?: number | null;

    /** 是否已经揭晓 ，预言类型帖子不为null */
    unlock?: boolean | null;

    /** 源站信息，非必填，编译时会用到，示例：{"title": "原文标题",  //非必填"link": "原文链接", //非必填"summary": "原文摘要" //非必填} */
    sourceInfo?: string | null;

    /** 文章标签,  可以通过标签获取图片地址：https://x0.ifengimg.com/fe/custom/bflow/blogLable/${lable}.png */
    labels?: string[] | null;

    /** 统计信息 */
    stat?: (Stat | null) | null;

    /** 引用详细信息，forwardStatus = 2 时，使用 */
    quoteItem?: (QuoteItem | null) | null;

    /** 转发详细信息，forwardStatus = 1 时，使用 */
    forwardItem?: (ForwardItem | null) | null;

    /** 转发的人相关信息，用于 forwardItem字段中的 forwardList，拼接转发信息 */
    fwUserInfo?: (FeedUserInfo | null) | null;

    /** 浏览数量，详情页使用 */
    browseNum?: number | null;

    /** 1 再用， 0 删除 */
    useFlag?: number | null;

    /** 展示样式，统计使用字段 */
    showtype?: string | null;

    /** 枚举值 */
    topicShowType?: 'normal' | 'highLight' | 'topicBarrage' | 'topicSquare' | null;

    /** topicShowType 为 topicBarrage、topicSquare 时，该字段不为空 */
    queueList?: FeedFlowItem[];

    /** 统计模型使用，放到前端 */
    recomToken?: string | null;

    /** 统计使用，主流曝光 */
    refType?: string | null;

    /** 标记：  神预言，精品 */
    mark?: string | null;

    /** 上下线状态    1 上线  -1 待处理  0 下线 */
    state?: number | null;

    /** 来源 */
    source?: string | null;

    /** 推文等级，1：低质，2：普通，3：良好，4：优质 */
    qlevel?: number | null;

    /** 一级分类 */
    cate?: string | null;

    /** 二级分类 */
    subcate?: string | null;

    /** 创建时间（yyyy-MM-dd HH:mm:ss） */
    ctime?: string | null;
}

export interface ForwardItem {
    /** 转发链长度 */
    forwardNum?: number | null;

    /** 转发链帖子信息 */
    forwardList?: ((FeedFlowItem | null) | null)[];
}

export interface QuoteItem {
    /** 共多少人引用 */
    quoteNum?: number | null;

    /** 应用帖子用户相关信息集合 */
    userInfoList?: (FeedUserInfo | null)[];

    /** 原始帖子信息 */
    originBlog?: FeedFlowItem | null;
}

export interface Stat {
    /** 帖子id */
    id?: string | null;

    /** 点赞数量 */
    like?: number | null;

    /** 分享数量 */
    share?: number | null;

    /** 转发数量 */
    forward?: number | null;

    /** 评论数量 */
    comment?: number | null;
}

export interface FeedUserInfo {
    /** 用户id */
    guid?: string | null;

    /** 昵称 */
    nickname?: string | null;

    /** 头像地址 */
    avatar?: string | null;

    /** 标签数组信息 */
    label?: (string | null)[];
}

export interface Topic {
    /** 【算法字段同步】话题唯一标识 */
    id?: string | null;

    /** 【算法字段同步】话题标题 */
    title?: string | null;

    /** 【算法字段同步】话题简介 */
    intro?: string | null;

    /** 头图 */
    thumbnail?: string | null;

    /** 背景图 */
    bgImgUrl?: string | null;

    /** 【算法字段同步】话题等级，1劣质，2普通，3良好，4优质 */
    qlevel?: number | null;

    /** 时效，100短，300正常，9999长效 */
    timeliness?: number | null;

    /** 【算法字段同步】过期时间，yyyy-MM-dd HH:mm:ss */
    expireTime?: string | null;

    /** 【算法字段同步】是否热门，0否，1是 */
    isHot?: number | null;

    /** 【算法字段同步】热门过期时间，yyyy-MM-dd HH:mm:ss */
    hotExpireTime?: string | null;

    /** 【算法字段同步】一级分类 */
    cate?: string | null;

    /** 【算法字段同步】二级分类 */
    subcate?: string | null;

    /** 【算法字段同步】标签 */
    tags?: string | null;

    /** 【算法字段同步】关联话题 */
    relateTopics?: string | null;

    /** 上下线状态，1上线，0下线 */
    state?: number | null;

    /** 【算法字段同步】推荐状态，2可推荐，0不推荐 */
    recomState?: number | null;

    /** 审核状态，1审核通过，0审核不通过 */
    checkStatus?: number | null;

    /** 创建人 */
    cuser?: string | null;

    /** 【算法字段同步】创建时间 */
    ctime?: string | null;

    /** 更新人 */
    uuser?: string | null;

    /** 【算法字段同步】更新时间 */
    utime?: string | null;

    /** 来源，前后frontend,后台backend */
    source?: string | null;

    /** 更新来源 */
    usource?: string | null;

    /** 用户信息{guid:xx,nickname:xx}，详见FeedUserInfo */
    userInfo?: string | null;

    /** 【算法字段同步】推文数 */
    docNum?: number | null;

    /** 【算法字段同步】推文更新时间 */
    docUtime?: string | null;

    /** 【算法字段同步】动态评分 */
    dynamicScore?: number | null;

    /** 【算法字段同步】人工干预评分 */
    manualScore?: number | null;

    /** 【算法字段同步】互动人数 */
    userNum?: number | null;

    /** 在用标识，1在用，0逻辑删除 */
    useFlag?: number | null;

    /** 审核系统给出的审核原因 */
    checkReason?: string | null;

    /** 推荐话题列表特有字段，用于日志上报 */
    reftype?: string | null;
}

export interface Root2 {
    operator?: { uid?: string; source?: string };
    webBlog?: { id?: string; checkStatus?: number; checkReason?: string };
}

export interface Root3 {
    /** 链接list */
    urlList?: string[];

    /** 临时链接时长（单位：分钟） */
    minute?: number;
}

export interface Root {
    operator?: { uid?: string; source?: string };
    id?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat;
    /** request body */
    body?: unknown;
    /** base url */
    baseUrl?: string;
    /** request cancellation token */
    cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string;
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
    securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
    customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D;
    error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = '';
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private abortControllers = new Map<CancelToken, AbortController>();
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    };

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig);
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key]);
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key];
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
        return keys
            .map((key) =>
                Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key),
            )
            .join('&');
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                        ? JSON.stringify(property)
                        : `${property}`,
                );
                return formData;
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    };

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }

        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);

        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter = this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;

        return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
            ...requestParams,
            headers: {
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
                ...(requestParams.headers || {}),
            },
            signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
            body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response as HttpResponse<T, E>;
            r.data = null as unknown as T;
            r.error = null as unknown as E;

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data;
                          } else {
                              r.error = data;
                          }
                          return r;
                      })
                      .catch((e) => {
                          r.error = e;
                          return r;
                      });

            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }

            if (!response.ok) throw data;
            return data;
        });
    };
}

/**
 * @title flowb
 * @version 1.0.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    topic = {
        /**
         * @description 响应： | 字段 | 类型 | 说明 | | --- | --- | --- | | code | int | 200成功 | | message | string | success或其他失败消息 | | data | [Topic](https://api.ifengcloud.ifeng.com/project/1862/interface/api/26709) | 见接口返回示例 |
         *
         * @tags 话题相关-Topic
         * @name DetailList
         * @summary 话题详情
         * @request GET:/topic/detail
         */
        detailList: (query?: { id?: string }, params: RequestParams = {}) =>
            this.request<
                {
                    code?: number;
                    data?: {
                        ctime?: string;
                        utime?: string;
                        cuser?: string;
                        uuser?: string;
                        usource?: string;
                        id?: string;
                        title?: string;
                        intro?: string;
                        checkStatus?: number;
                        checkReason?: string;
                        checkTime?: string;
                        useFlag?: number;
                        thumbnail?: null;
                        bgImgUrl?: string;
                        bgColor?: string;
                        docNum?: number | null;
                        docUtime?: null;
                        isHot?: null;
                        hotExpireTime?: null;
                        timeliness?: null;
                        expireTime?: null;
                        state?: null;
                        recomState?: null;
                        relateTopics?: null;
                        qlevel?: null;
                        cate?: null;
                        subcate?: null;
                        tags?: null;
                        userNum?: null;
                        dynamicScore?: null;
                        manualScore?: null;
                        userInfo?: null;
                        source?: string;
                    };
                    message?: string;
                },
                any
            >({
                path: `/topic/detail`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    };
    feed = {
        /**
         * No description
         *
         * @tags 话题相关-Topic
         * @name TopicDocPolymerCreate
         * @summary 话题聚合页
         * @request POST:/feed/topicDocPolymer
         */
        topicDocPolymerCreate: (
            data: {
                uid?: string;
                guid?: string;
                searchGuid?: string;
                topicId?: string;
                webBlogId?: string;
                type?: 'hot' | 'latest';
                pushCount: number;
                pullCount: number;
                operation?: 'pullDown' | 'pullUp' | 'default';
                loc?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<
                {
                    code: number;
                    message: string;
                    data?: {
                        asc?: (string | null)[];
                        ascs?: (string | null)[];
                        countId?: string | null;
                        current?: number | null;
                        desc?: (string | null)[];
                        descs?: (string | null)[];
                        hitCount?: boolean | null;
                        maxLimit?: number | null;
                        optimizeCountSql?: boolean | null;
                        orders?: (string | null)[];
                        pages?: number | null;
                        records?: (FeedFlowItem | null)[];
                        searchCount?: boolean | null;
                        size?: number | null;
                        total?: number | null;
                    };
                },
                any
            >({
                path: `/feed/topicDocPolymer`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * @description 测试环境示例： [https://bflow-front-test.ifengidc.com/feed/detail/6915633610385006592](https://bflow-front-test.ifengidc.com/webBlog/detail?id=6915633610385006592) 返回体： { “code”:200, "message":  "success", "data":  object   参照：[FeedFlowItem](https://api.ifengcloud.ifeng.com/project/1862/interface/api/28854) }
         *
         * @tags 信息流
         * @name DetailDetail
         * @summary 帖子流内详情
         * @request GET:/feed/detail/{id}
         */
        detailDetail: (id: string, params: RequestParams = {}) =>
            this.request<{ code?: number; data?: FeedFlowItem; message?: string }, any>({
                path: `/feed/detail/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * @description 测试环境接口： [https://bflow-front-test.ifengidc.com/feed/userDocList?guid=4000000087996620625&page=1&size=5](https://bflow-front-test.ifengidc.com/feed/userDocList?guid=4000000087996620625&page=1&size=5) 返回字段说明： | 字段 | 类型 | 说明 | | --- | --- | --- | | code | int | 200成功，其他失败 | | message | string | 提示信息 | | data | jsonarray | 内容列表，格式见：xxx | |  |  |  | |  |  |  | |  |  |  | |  |  |  | |  |  |  |
         *
         * @tags 个人主页
         * @name UserDocPolymerCreate
         * @summary 个人页信息聚合流
         * @request POST:/feed/userDocPolymer
         */
        userDocPolymerCreate: (
            data: {
                uid?: string;
                guid?: string;
                searchGuid?: string;
                topicId?: string;
                webBlogId?: string;
                type?: 'Doc' | 'ShortPost' | 'FW' | 'Trans' | 'Predicate' | 'Media';
                pushCount: number;
                pullCount: number;
                operation?: 'pullDown' | 'pullUp' | 'default';
                loc?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<
                {
                    code: number;
                    message: string;
                    data?: {
                        asc?: (string | null)[];
                        ascs?: (string | null)[];
                        countId?: string | null;
                        current?: number | null;
                        desc?: (string | null)[];
                        descs?: (string | null)[];
                        hitCount?: boolean | null;
                        maxLimit?: number | null;
                        optimizeCountSql?: boolean | null;
                        orders?: (string | null)[];
                        pages?: number | null;
                        records?: (FeedFlowItem | null)[];
                        searchCount?: boolean | null;
                        size?: number | null;
                        total?: number | null;
                    };
                },
                any
            >({
                path: `/feed/userDocPolymer`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    api = {
        /**
         * @description 通过投票id（id）和用户id（guid）获取该用户的投票结果。
         *
         * @tags 分享
         * @name WordthingUserSurveyDetail
         * @summary 获取用户投票结果
         * @request GET:/api/wordthing/user/survey/{id}/{guid}
         */
        wordthingUserSurveyDetail: (id: string, guid: string, params: RequestParams = {}) =>
            this.request<
                {
                    code: 0 | 1;
                    message: string;
                    data?: {
                        nickname?: string;
                        userimg?: string;
                        result?: { questionid?: string; option_id?: string; title?: string }[];
                    };
                },
                any
            >({
                path: `/api/wordthing/user/survey/${id}/${guid}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
}
